<template>
    <section class="not-found-page">
        <div class="not-found-card">
            <div class="row align-items-center g-4">
                <div class="col-lg-7">
                    <span class="not-found-eyebrow">Página não encontrada</span>
                    <h1 class="not-found-title">Ops, este caminho não existe.</h1>
                    <p class="not-found-description">
                        A rota informada pode ter sido removida, renomeada ou digitada incorretamente.
                        Use uma das opções abaixo para continuar navegando com segurança.
                    </p>

                    <div class="not-found-path" v-if="invalidPath">
                        <span>Rota acessada</span>
                        <strong>{{ invalidPath }}</strong>
                    </div>

                    <div class="d-flex flex-column flex-sm-row gap-2 mt-4">
                        <router-link class="btn btn-primary px-4" :to="{name: 'Home'}">
                            Ir para a Home
                        </router-link>
                        <button class="btn btn-outline-secondary px-4" type="button" @click="goBack">
                            Voltar página anterior
                        </button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="not-found-visual" aria-hidden="true">
                        <div class="not-found-orbit not-found-orbit-one"></div>
                        <div class="not-found-orbit not-found-orbit-two"></div>
                        <div class="not-found-code">404</div>
                        <div class="not-found-compass">
                            <i class="icon-search1"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'NotFoundComponent',
    computed: {
        invalidPath() {
            return this.$route.fullPath;
        },
    },
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }

            this.$router.push({name: 'Home'});
        },
    },
}
</script>
